// pages/SubmissionRequests.tsx
import React from "react";
import Button from "../components/Button";
import DataTableView from "../components/DataTableView2";
import ViewRequest from "../components/requests/ViewRequest";
import { TruncatedText } from "../components/truncated";
import useSubmissionRequests from '../hooks/logics/submission-request/use-submisssion-request-dashboard';
import { SUBMISSION_REQUEST_STATUSES, submissionRequestDriver } from "../utils/types";

const SubmissionRequests = () => {
  const {
    submissions, totalPages, isFetching,
    currentPage, setCurrentPage,
    loadingId, selectedRequest,
    isViewSelectedModalShowing,
    handleModifyRequest,
    handleCloseViewRequest,
  } = useSubmissionRequests();

  const columns = [
    {
      header: "Name",
      className: "md:p-0 md:pl-10",
      accessor: (submission: submissionRequestDriver) => (
        <div className="flex items-center cursor-pointer md:!pl-7">
          <div className="flex-shrink-0 w-8 h-8 border border-black rounded-full">
            <img
              onError={(e) => { (e.target as HTMLImageElement).src = "https://www.pngfind.com/pngs/m/610-6104451_image-placeholder-png-user-profile-placeholder-image-png.png"; }}
              className="w-full rounded-full h-full object-cover"
              src={submission.driver?.profileImage}
            />
          </div>
          <p className="ml-2 truncate text-md text-gray-900 font-normal">
            {submission.driver?.fullName || "N/A"}
          </p>
        </div>
      ),
    },
    {
      header: "Email",
      accessor: (submission: submissionRequestDriver) => submission.driver?.email || "N/A",
    },
    {
      header: "Reason",
      accessor: (submission: submissionRequestDriver) => (
        <TruncatedText text={submission.reason} limit={24} />
      ),
    },
    {
      header: "Actions",
      accessor: (submission: submissionRequestDriver) => {
        const isPending = submission.status === SUBMISSION_REQUEST_STATUSES.PENDING_REVIEW;
        const isApproved = submission.status === SUBMISSION_REQUEST_STATUSES.APPROVED;

        if (isPending) return (
          <div className="flex gap-2">
            <Button
              disabled={loadingId === submission._id}
              onClick={() => handleModifyRequest(submission._id, SUBMISSION_REQUEST_STATUSES.APPROVED)}
              className="p-2"
            >
              Approve
            </Button>
            <Button
              disabled={loadingId === submission._id}
              onClick={() => handleModifyRequest(submission._id, SUBMISSION_REQUEST_STATUSES.REJECTED)}
              className="text-red-600 border-none !bg-transparent"
              variant="outline"
            >
              Reject
            </Button>
          </div>
        );

        return isApproved
          ? <p className="text-primary">Request approved</p>
          : <p className="text-red-600">Request rejected</p>;
      },
    },
  ];

  return (
    <>
      <div className="w-full h-full">
        <DataTableView
          data={submissions}
          columns={columns}
          isFetching={isFetching}
          emptyStateMessage="No data found"
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalPages={totalPages}
        />
      </div>

      <ViewRequest
        isVisible={isViewSelectedModalShowing}
        request={selectedRequest}
        onClose={handleCloseViewRequest}
      />
    </>
  );
};

export default SubmissionRequests;